export default "__VITE_ASSET__CC9Txzur__"